module.exports = __webpack_public_path__ + "img/tren.40644cc0.png";